import { render } from "./FpuiDashboardingLayoutLite.vue?vue&type=template&id=10ef214a&lang=pug"
import script from "./FpuiDashboardingLayoutLite.vue?vue&type=script&lang=js"
export * from "./FpuiDashboardingLayoutLite.vue?vue&type=script&lang=js"

import "./FpuiDashboardingLayoutLite.vue?vue&type=style&index=0&id=10ef214a&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__